import { ResizeHandle } from 'designSystem/components/ResizeHandle'
import { cn } from 'designSystem/lib/utils'
import * as ResizablePrimitive from 'react-resizable-panels'

function ResizablePanelGroup({
  className,
  ...props
}: ResizablePrimitive.GroupProps) {
  return (
    <ResizablePrimitive.Group
      data-slot='resizable-panel-group'
      className={cn(
        'flex h-full w-full aria-[orientation=vertical]:flex-col',
        className
      )}
      {...props}
    />
  )
}

function ResizablePanel({ ...props }: ResizablePrimitive.PanelProps) {
  return <ResizablePrimitive.Panel data-slot='resizable-panel' {...props} />
}

const coarsePointerBandClassName =
  'pointer-coarse:w-3 pointer-coarse:bg-transparent pointer-coarse:after:w-px pointer-coarse:after:bg-border pointer-coarse:aria-[orientation=horizontal]:h-3 pointer-coarse:aria-[orientation=horizontal]:after:h-px pointer-coarse:aria-[orientation=horizontal]:after:top-1/2'

function ResizableHandle({
  withHandle,
  variant = 'default',
  className,
  ...props
}: ResizablePrimitive.SeparatorProps & {
  variant?: 'default' | 'hover' | 'grabber'
  withHandle?: boolean
}) {
  if (variant === 'grabber') {
    return (
      <ResizeHandle asChild className={className}>
        <ResizablePrimitive.Separator data-slot='resizable-handle' {...props} />
      </ResizeHandle>
    )
  }

  return (
    <ResizablePrimitive.Separator
      data-slot='resizable-handle'
      className={cn(
        'relative flex w-px items-center justify-center bg-border ring-offset-background after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-hidden aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:translate-x-0 aria-[orientation=horizontal]:after:-translate-y-1/2 [&[aria-orientation=horizontal]>div]:rotate-90',
        variant === 'hover' &&
          'bg-transparent after:w-px after:bg-transparent hover:after:bg-border active:after:bg-border focus-visible:ring-0 focus-visible:after:bg-transparent data-[resize-handle-active]:after:bg-border',
        coarsePointerBandClassName,
        className
      )}
      {...props}>
      {withHandle && (
        <div className='z-10 flex h-6 w-1 shrink-0 rounded-lg bg-border' />
      )}
    </ResizablePrimitive.Separator>
  )
}

export { ResizableHandle, ResizablePanel, ResizablePanelGroup }
